import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { Dialog, FlatButton, FloatingActionButton } from 'material-ui';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
import styles from './News.css';
import { deleteOneNews, getNews, resetOneNews } from '../../store/news/actions';
import withTranslation from '../../hoc/withTranslation';
import { search, setOxListMode, setOxMode } from '../../store/ui/actions';
import SearchBox from '../../components/common/SearchBox/SearchBox';
import Loading from '../../components/common/Loading/Loading';
import NewsList from '../../components/news/NewsList';
import { ADD_NEWS_PAGE, NEWS_PAGE } from '../../constants/routes';
import { fetchApp } from '../../store/apps/actions';
import { DisplayMode } from '../../components/report/Reports/Reports';
import { ADMIN } from '../../services/admin';
import AdminService from '../../services/admin';

export class NewsListPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        match: PropTypes.object,
        currentLang: PropTypes.string,
        sending: PropTypes.bool,
        loading: PropTypes.bool,
        news: PropTypes.array,
        user: PropTypes.object,
        navLeftPadding: PropTypes.number,
        searchValue: PropTypes.string,
        listMode: PropTypes.number,
        getNews: PropTypes.func,
        fetchApp: PropTypes.func,
        search: PropTypes.func,
        deleteOneNews: PropTypes.func,
        resetOneNews: PropTypes.func,
        setOxListMode: PropTypes.func,
        setOxMode: PropTypes.func,
        lang: PropTypes.string,
    };

    static defaultProps = {
        loading: true,
        app: null,
    };

    state = {
        floatingPopoverOpened: false,
        floatingAnchorElement: null,
        openRemoveNews: false,
        newsToRemove: null,
    };

    componentWillMount() {
        this.props.setOxMode(DisplayMode.MODE_LIST);
        this.props.resetOneNews();
        this.fetchApplication();
        if (this.props.app && this.props.currentLang) {
            this.props.getNews(this.props.app, this.props.currentLang);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetchApplication(nextProps.match.params.appId);
        }

        if (this.props.app !== nextProps.app && nextProps.app && nextProps.currentLang) {
            this.props.getNews(nextProps.app, nextProps.currentLang);
        }
    }

    // Logic

    fetchApplication(appId = null) {
        if (this.props.match) {
            let id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    filteredNews() {
        const { searchValue } = this.props;

        if (!searchValue || searchValue.length === 0) {
            return this.props.news;
        }
        const keys = Object.keys(this.props.news);
        const filteredNews = Object.fromEntries(
            keys.map(key => [key, []])
        );
        for (const key of keys) {
            filteredNews[key] = this.props.news[key].filter((news) => {
                const includesName = news.title && news.title.includes(searchValue);
                const includesDesc = news.description && news.description.includes(searchValue);
                return includesName || includesDesc;
            });
        }
        return filteredNews;
    }

    // Handlers

    onNewsClicked = (news) => {
        let url = NEWS_PAGE.replace(':appId', this.props.app.id).replace(':newsId', news.id);
        this.props.history.push(url);
    };
    onAddNewsClicked = () => {
        let url = ADD_NEWS_PAGE.replace(':appId', this.props.app.id);
        this.props.history.push(url);

    };
    onSearchChanged = (event, value) => {
        this.props.search(value);
    };

    // Delete point

    handleCloseNews = () => {
        this.setState({
            openRemoveNews: false,
            newsToRemove: null,
        });
    };

    deleteNews = () => {
        this.props.deleteNews(this.props.app.id, this.state.newsToRemove.id, this.props.currentLang);
    };

    // Floating Button

    handleOpenFloatingButton = (event) => {
        event.preventDefault();

        this.setState({
            floatingPopoverOpened: true,
            floatingAnchorElement: event.currentTarget,
        });
    };

    handleCloseFloatingButton = () => {
        this.setState({
            floatingPopoverOpened: false,
            floatingAnchorElement: null,
        });
    };

    // Render

    toolbarContainerStyle() {
        let style = styles.toolBar.container;

        style = {
            ...style,
            ...styles.toolBar.containerList,
        };

        return style;
    }

    renderToolbar() {
        return (
            <Toolbar style={this.toolbarContainerStyle()}>
                <ToolbarGroup
                    firstChild={true}
                    style={styles.toolBar.searchBar}
                >
                    <SearchBox
                        onChange={this.onSearchChanged}
                        value={this.props.searchValue}
                    />
                </ToolbarGroup>
            </Toolbar>
        );
    }

    renderList(news) {
        let bottomNavigationBarStyle = styles.list.bottomNavigationBar;
        bottomNavigationBarStyle.paddingLeft = this.props.navLeftPadding;

        return (
            <div>
                <div style={styles.list.container}>
                    <NewsList
                        app={this.props.app}
                        user={this.props.user}
                        news={news}
                        title={this.props.t('module.news.plural')}
                        currentLang={this.props.currentLang}
                    />
                </div>
            </div>
        );
    }

    renderDeleteNewsDialog(news) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseNews}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteNews}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={this.props.sending}
                open={this.state.openRemoveNews}
                onRequestClose={this.handleClosePoint}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                    <p>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: this.props.t('module.news.delete_news_confirmation', {
                                    name: news.name,
                                }),
                            }}
                        />
                    </p>
                }
            </Dialog>
        );
    }

    renderFloatingButton() {
        return (
            <div>
                <FloatingActionButton
                    style={styles.floatingButton}
                    onClick={this.onAddNewsClicked}
                >
                    <ContentAdd />
                </FloatingActionButton>
            </div>
        );
    }

    render() {
        // No app loading anyway
        if (!this.props.app || this.props.loading) {
            return <Loading paper={false} />;
        }

        const news = this.filteredNews() || [];

        return (
            <div style={styles.container}>
                {this.state.newsToRemove && this.renderDeleteNewsDialog(this.state.newsToRemove)}

                {this.renderList(news)}

                {this.renderToolbar()}
                {AdminService.isAuthorized(ADMIN, this.props.user) && this.renderFloatingButton()}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        sending: state.news.sending,
        loading: state.news.pending,
        news: state.news.content,
        user: state.auth.content,
        currentLang: state.ui.currentLang,
        navLeftPadding: state.ui.leftPadding,
        searchValue: state.ui.search,
        listMode: state.ui.oxListMode,
    };

    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }

    if (!ownProps.mode) {
        props.mode = state.ui.oxMode;
    }

    if (!ownProps.listMode) {
        props.listMode = state.ui.oxListMode;
    }

    return props;
}

export default connect(mapStateToProps, {
    getNews,
    fetchApp,
    search,
    deleteOneNews,
    resetOneNews,
    setOxListMode,
    setOxMode,
})(withRouter(withTranslation(NewsListPage)));



// WEBPACK FOOTER //
// src/containers/news/NewsListPage.js